import { apiClient } from '../api-client.config';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

export interface UploadImageRequest {
  path: string;
  filename: string;
  imageData: string;
  /** When true, upload to exact path/filename without appending a timestamp */
  overwrite?: boolean;
}

export interface UploadImageResponse {
  imageUrl: string;
  path: string;
  filename: string;
  message: string;
}

export const uploadImage = async (data: UploadImageRequest): Promise<UploadImageResponse> => {
  // Using type assertion to bypass strict path typing since this endpoint isn't in generated types yet
  const response = await (apiClient.post as any)('/api/admin/upload/image', data);
  return response as UploadImageResponse;
};

export interface UseUploadImageMutationOptions {
  onSuccess?: (url: string) => void;
  showToast?: boolean;
}

export const useUploadImageMutation = (options?: UseUploadImageMutationOptions) => {
  const { onSuccess, showToast = true } = options ?? {};

  return useMutation({
    mutationFn: uploadImage,
    onSuccess: data => {
      if (showToast) {
        toast.success('Image uploaded successfully');
      }
      onSuccess?.(data.imageUrl);
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.error || error?.message || 'Failed to upload image';
      toast.error(errorMessage);
    },
  });
};
